<div class="p-grid mt-2">
	<div class="col-6" (click)="checkSelectorChange.emit(true)">Check {{ posService.orderService.activeOrder.value.checkNumber }}</div>
	<div class="col-3">Table</div>
	<div class="col-3">
		{{ posService.orderService.activeOrder.value.table }}
	</div>
</div>
<div class="p-grid">
	<div class="col-6">
		{{ posService.orderService.activeOrder.value.owner }}
	</div>
	<div class="col-3 text-capitalize">Guests</div>
	<div class="col-3">
		{{ posService.orderService.activeOrder.value.numberOfGuests }}
	</div>
</div>
<p-dropdown
	*ngIf="seatPickerOptions.length > 1"
	#checkSeatSelector
	[options]="seatPickerOptions"
	optionLabel="label"
	optionValue="value"
	name="checkSeatSelector"
	[(ngModel)]="selectedSeatKey"
	[style]="{ width: '100%' }"
	appendTo="body"
	(onChange)="onSeatSelect(selectedSeatKey)"
></p-dropdown>
